export enum CashbackPopups {
  WelcomeGift = 'WelcomeGift',
  SpinTheWheel = 'SpinTheWheel',
  Bogo = 'bogo',
  Cashback = 'Cashback'
}
